import { render, staticRenderFns } from "./PointMessage.vue?vue&type=template&id=be5dea58"
import script from "./PointMessage.vue?vue&type=script&lang=js"
export * from "./PointMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports